import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { expanded: Boolean }
  static targets = ["chevron", "content"]

  toggle() {
    // In the collapsed rail there is nowhere to show the children — they're label-only, and the CSS
    // hides them — so the click means "let me get at these", not "toggle". Open the sidebar and this
    // group with it, rather than silently doing nothing.
    if (this.element.closest("aside")?.dataset.collapsed === "true") {
      this.dispatch("expandSidebar", { prefix: "sidebar-nav-group" })
      this.expandedValue = true
      return
    }

    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    if (this.expandedValue) {
      this.contentTarget.classList.remove("max-h-0")
      this.contentTarget.classList.add("max-h-96")
      this.chevronTarget.classList.add("rotate-90")
    } else {
      this.contentTarget.classList.add("max-h-0")
      this.contentTarget.classList.remove("max-h-96")
      this.chevronTarget.classList.remove("rotate-90")
    }
  }
}
